import mutations from '@/store/modules/alertV2/tagGrouping/tagGrouping.mutations';
import getters from '@/store/modules/alertV2/tagGrouping/tagGrouping.getters';
import actions from '@/store/modules/alertV2/tagGrouping/tagGrouping.actions';
import {
  FormUtils,
  TagFormFieldOptions,
  TagTableInfo
} from '@/store/modules/alertV2/tagGrouping/interfaces';
import {
  tagFormDefaultData,
  tagFormFieldOptions,
  tagTableInfo
} from '@/components/AlertsV2/tag-grouping/tags.types';
import _ from 'lodash';

export interface GroupConditionObj {
  isAnd: boolean;
  value1: string;
  value2: string;
  isValid: boolean;
}

interface TagGroupNameInfo {
  groupingConditions: Array<GroupConditionObj>;
  groupName: string;
  tagId: string;
  groupingCondition: string;
  groupingLabeledKeyExpression: string;
  tagGroupId: string;
}

interface TimeFrameInfo {
  aggTime: string;
  notificationText: string;
}

interface NotificationInfo {
  channels: Array<string>;
  priority: string;
}
export interface TagFormData {
  tagGroupNameInfo: TagGroupNameInfo;
  timeFrameInfo: TimeFrameInfo;
  notificationInfo: NotificationInfo;
  formUtils: FormUtils;
}

export interface State {
  isTagFormOpened: boolean;
  isTagFormEdit: boolean;
  tagFormEditInitData: TagFormData;
  tagFormData: TagFormData;
  tagFormFieldOptions: TagFormFieldOptions;
  tagTableInfo: TagTableInfo;
}

export const initialState: State = {
  isTagFormOpened: false,
  isTagFormEdit: false,
  tagFormEditInitData: _.cloneDeep(tagFormDefaultData),
  tagFormData: _.cloneDeep(tagFormDefaultData),
  tagFormFieldOptions: _.cloneDeep(tagFormFieldOptions),
  tagTableInfo: _.cloneDeep(tagTableInfo)
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  getters: getters,
  actions: actions
};
